import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'app/components/misc/ErrorPage';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import PrivacyContent from 'app/pageContents/PrivacyContent';
import prismicApi from 'app/api/prismicApi';
import { PAGE_TYPE } from 'app/constants/app';
import { configureStaticPageHead } from 'app/utils/configurePageHead';
import { RichText } from 'prismic-reactjs';
import get from 'lodash/get';

const propTypes = {
  doc: PropTypes.object,
};

const Privacy = ({ doc }) => {
  if (!doc) return <ErrorPage />;

  if (doc) {
    return (
      <Page withBackground>
        <PageHead
          {...configureStaticPageHead(
            PAGE_TYPE.PRIVACY,
            RichText.asText(doc.version),
          )}
        />
        <PrivacyContent doc={doc} />
      </Page>
    );
  }
};

Privacy.getInitialProps = async ({ res }) => {
  const response = await prismicApi('document.type', 'privacy');
  const doc = get(response, 'results[0].data');
  if (res && !doc) res.statusCode = 404;
  return { doc };
};

Privacy.propTypes = propTypes;

export default Privacy;
